import actionTypes from '../../actions/actionTypes';

const _initState = {
  isLoading: false,
  data: null
};

const dodavatelCurrentUser = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_DODAVATEL_CURRENT_USER_REQUEST:  
      return { ...state, isLoading: true };

    case actionTypes.GET_DODAVATEL_CURRENT_USER_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };
    
    case actionTypes.GET_DODAVATEL_CURRENT_USER_FAILURE:
      return _initState;


    default:
      return state
  }
};

export default dodavatelCurrentUser;